// AUTO GENERATED from src/pages and src/app. run `yarn generate:manifest` to refresh.
import { RouteName } from '@shared/constants/routes'
import { type ParamMap } from '@next-types/routes'

export type GeneratedRouteEntry = {
  urlPattern: keyof ParamMap
  regex: RegExp
  routeNames: RouteName[]
  // which src dir the page came from. client navigation needs this because the app
  // router has no route table for pages routes and would otherwise probe the server.
  router: 'app' | 'pages'
}

export const routeAccessManifest: GeneratedRouteEntry[] = [
  {
    urlPattern: '/',
    regex: /^\/(?:\/)?$/,
    routeNames: [RouteName.UNGATED_HOMEPAGE],
    router: 'pages',
  },
  { urlPattern: '/about', regex: /^\/about(?:\/)?$/, routeNames: [RouteName.ABOUT], router: 'app' },
  {
    urlPattern: '/assistant',
    regex: /^\/assistant(?:\/)?$/,
    routeNames: [RouteName.ASSISTANT_LANDING],
    router: 'pages',
  },
  {
    urlPattern: '/auth/error',
    regex: /^\/auth\/error(?:\/)?$/,
    routeNames: [RouteName.AUTH0_ERROR],
    router: 'pages',
  },
  { urlPattern: '/blog', regex: /^\/blog(?:\/)?$/, routeNames: [RouteName.BLOG], router: 'app' },
  {
    urlPattern: '/blog/[...slug]',
    regex: /^\/blog\/(.+?)(?:\/)?$/,
    routeNames: [RouteName.BLOG_POST],
    router: 'app',
  },
  {
    urlPattern: '/categories',
    regex: /^\/categories(?:\/)?$/,
    routeNames: [RouteName.UNGATED_CATEGORY_HUB],
    router: 'pages',
  },
  {
    urlPattern: '/categories/[...slug]',
    regex: /^\/categories\/(.+?)(?:\/)?$/,
    routeNames: [RouteName.UNGATED_CATEGORY],
    router: 'pages',
  },
  {
    urlPattern: '/cms/bulk-content-preview',
    regex: /^\/cms\/bulk\-content\-preview(?:\/)?$/,
    routeNames: [RouteName.CMS_BULK_CONTENT_PREVIEW],
    router: 'pages',
  },
  {
    urlPattern: '/cms/module/[id]',
    regex: /^\/cms\/module\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.CMS_MODULE],
    router: 'pages',
  },
  {
    urlPattern: '/cms/page',
    regex: /^\/cms\/page(?:\/)?$/,
    routeNames: [RouteName.CMS_PREVIEW_PAGE],
    router: 'pages',
  },
  {
    urlPattern: '/contact',
    regex: /^\/contact(?:\/)?$/,
    routeNames: [RouteName.CONTACT],
    router: 'pages',
  },
  {
    urlPattern: '/email-verification-required',
    regex: /^\/email\-verification\-required(?:\/)?$/,
    routeNames: [RouteName.EMAIL_VERIFICATION_REQUIRED],
    router: 'pages',
  },
  {
    urlPattern: '/group-invites',
    regex: /^\/group\-invites(?:\/)?$/,
    routeNames: [RouteName.INVITES_INTERIM],
    router: 'pages',
  },
  {
    urlPattern: '/login',
    regex: /^\/login(?:\/)?$/,
    routeNames: [RouteName.LOGIN],
    router: 'pages',
  },
  {
    urlPattern: '/logout',
    regex: /^\/logout(?:\/)?$/,
    routeNames: [RouteName.LOGOUT],
    router: 'pages',
  },
  {
    urlPattern: '/onepass',
    regex: /^\/onepass(?:\/)?$/,
    routeNames: [RouteName.ONE_PASS],
    router: 'pages',
  },
  {
    urlPattern: '/password-reset',
    regex: /^\/password\-reset(?:\/)?$/,
    routeNames: [RouteName.PASSWORD_RESET],
    router: 'pages',
  },
  {
    urlPattern: '/privacy/driver-intake-form',
    regex: /^\/privacy\/driver\-intake\-form(?:\/)?$/,
    routeNames: [RouteName.DRIVER_INTAKE_FORM],
    router: 'pages',
  },
  {
    urlPattern: '/privacy/intake-form',
    regex: /^\/privacy\/intake\-form(?:\/)?$/,
    routeNames: [RouteName.PRIVACY_RIGHTS_REQUESTS],
    router: 'pages',
  },
  {
    urlPattern: '/promotions/[promotion_category_id]',
    regex: /^\/promotions\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.UNGATED_PROMOTIONS_PAGE],
    router: 'pages',
  },
  {
    urlPattern: '/secure/add-gift-card-payment',
    regex: /^\/secure\/add\-gift\-card\-payment(?:\/)?$/,
    routeNames: [RouteName.SECURE_ADD_GIFT_CARD_PAYMENT],
    router: 'pages',
  },
  {
    urlPattern: '/secure/add-membership-payment',
    regex: /^\/secure\/add\-membership\-payment(?:\/)?$/,
    routeNames: [RouteName.SECURE_ADD_MEMBERSHIP_PAYMENT],
    router: 'pages',
  },
  {
    urlPattern: '/secure/add-payment',
    regex: /^\/secure\/add\-payment(?:\/)?$/,
    routeNames: [RouteName.SECURE_ADD_PAYMENT],
    router: 'pages',
  },
  {
    urlPattern: '/secure/choose-membership-payment',
    regex: /^\/secure\/choose\-membership\-payment(?:\/)?$/,
    routeNames: [RouteName.SECURE_CHOOSE_MEMBERSHIP_PAYMENT],
    router: 'pages',
  },
  {
    urlPattern: '/shop',
    regex: /^\/shop(?:\/)?$/,
    routeNames: [RouteName.GLOBAL_HOMEPAGE],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/accessibility',
    regex: /^\/shop\/account\/accessibility(?:\/)?$/,
    routeNames: [RouteName.ACCESSIBILITY],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/addresses',
    regex: /^\/shop\/account\/addresses(?:\/)?$/,
    routeNames: [RouteName.ADDRESS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/advanced-security',
    regex: /^\/shop\/account\/advanced\-security(?:\/)?$/,
    routeNames: [RouteName.ADVANCED_SECURITY],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/business-details',
    regex: /^\/shop\/account\/business\-details(?:\/)?$/,
    routeNames: [RouteName.BUSINESS_DETAILS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/business-manage-users',
    regex: /^\/shop\/account\/business\-manage\-users(?:\/)?$/,
    routeNames: [RouteName.BUSINESS_MANAGE_USERS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/business-tools',
    regex: /^\/shop\/account\/business\-tools(?:\/)?$/,
    routeNames: [RouteName.BUSINESS_TOOLS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/data-privacy',
    regex: /^\/shop\/account\/data\-privacy(?:\/)?$/,
    routeNames: [RouteName.DATA_PRIVACY],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/dietary-preferences',
    regex: /^\/shop\/account\/dietary\-preferences(?:\/)?$/,
    routeNames: [RouteName.DIETARY_PREFERENCES],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/invites',
    regex: /^\/shop\/account\/invites(?:\/)?$/,
    routeNames: [RouteName.INVITES],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/notifications',
    regex: /^\/shop\/account\/notifications(?:\/)?$/,
    routeNames: [RouteName.NOTIFICATIONS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/orders',
    regex: /^\/shop\/account\/orders(?:\/)?$/,
    routeNames: [RouteName.ORDER_LIST],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/orders/substitution-preferences/[id]',
    regex: /^\/shop\/account\/orders\/substitution\-preferences\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.SUBSTITUTION_PREFERENCES_ORDER],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/orders/[id]',
    regex: /^\/shop\/account\/orders\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.ORDER_DETAIL],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/preferred',
    regex: /^\/shop\/account\/preferred(?:\/)?$/,
    routeNames: [RouteName.PREFERRED],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/profile',
    regex: /^\/shop\/account\/profile(?:\/)?$/,
    routeNames: [RouteName.PROFILE],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/rewards',
    regex: /^\/shop\/account\/rewards(?:\/)?$/,
    routeNames: [RouteName.REWARD],
    router: 'pages',
  },
  {
    urlPattern: '/shop/account/wallet',
    regex: /^\/shop\/account\/wallet(?:\/)?$/,
    routeNames: [RouteName.WALLET],
    router: 'pages',
  },
  {
    urlPattern: '/shop/add-business-profile',
    regex: /^\/shop\/add\-business\-profile(?:\/)?$/,
    routeNames: [RouteName.BUSINESS_ADD_PROFILE],
    router: 'pages',
  },
  {
    urlPattern: '/shop/branch',
    regex: /^\/shop\/branch(?:\/)?$/,
    routeNames: [RouteName.BRANCH],
    router: 'pages',
  },
  {
    urlPattern: '/shop/branch/u',
    regex: /^\/shop\/branch\/u(?:\/)?$/,
    routeNames: [RouteName.BRANCH_UNGATED],
    router: 'pages',
  },
  {
    urlPattern: '/shop/buy_again',
    regex: /^\/shop\/buy_again(?:\/)?$/,
    routeNames: [RouteName.BUY_AGAIN],
    router: 'pages',
  },
  {
    urlPattern: '/shop/cart',
    regex: /^\/shop\/cart(?:\/)?$/,
    routeNames: [RouteName.CART],
    router: 'pages',
  },
  {
    urlPattern: '/shop/cart/loading',
    regex: /^\/shop\/cart\/loading(?:\/)?$/,
    routeNames: [RouteName.CART_CONVERSION_LOADING],
    router: 'pages',
  },
  {
    urlPattern: '/shop/cart-builder',
    regex: /^\/shop\/cart\-builder(?:\/)?$/,
    routeNames: [RouteName.CART_BUILDER],
    router: 'pages',
  },
  {
    urlPattern: '/shop/checkout',
    regex: /^\/shop\/checkout(?:\/)?$/,
    routeNames: [RouteName.CHECKOUT],
    router: 'pages',
  },
  {
    urlPattern: '/shop/choose-membership',
    regex: /^\/shop\/choose\-membership(?:\/)?$/,
    routeNames: [RouteName.CHOOSE_MEMBERSHIP],
    router: 'pages',
  },
  {
    urlPattern: '/shop/coupon/[id]',
    regex: /^\/shop\/coupon\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.COUPON],
    router: 'pages',
  },
  {
    urlPattern: '/shop/coupons',
    regex: /^\/shop\/coupons(?:\/)?$/,
    routeNames: [RouteName.COUPONS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/deals',
    regex: /^\/shop\/deals(?:\/)?$/,
    routeNames: [RouteName.DEALS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/featured-promotions/[promotion_category_id]',
    regex: /^\/shop\/featured\-promotions\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.FEATURED_PROMOTIONS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/guest-welcome',
    regex: /^\/shop\/guest\-welcome(?:\/)?$/,
    routeNames: [RouteName.GUEST_WELCOME],
    router: 'pages',
  },
  {
    urlPattern: '/shop/kits',
    regex: /^\/shop\/kits(?:\/)?$/,
    routeNames: [RouteName.KITS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/kits/[id]',
    regex: /^\/shop\/kits\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.KIT_DETAIL],
    router: 'pages',
  },
  {
    urlPattern: '/shop/landing-page/for-you',
    regex: /^\/shop\/landing\-page\/for\-you(?:\/)?$/,
    routeNames: [RouteName.LANDING_PAGE_FOR_YOU],
    router: 'pages',
  },
  {
    urlPattern: '/shop/landing-page/[...params]',
    regex: /^\/shop\/landing\-page\/(.+?)(?:\/)?$/,
    routeNames: [RouteName.LANDING_PAGE],
    router: 'pages',
  },
  {
    urlPattern: '/shop/lists',
    regex: /^\/shop\/lists(?:\/)?$/,
    routeNames: [RouteName.LISTS_HUB],
    router: 'pages',
  },
  {
    urlPattern: '/shop/lists/share/[token]',
    regex: /^\/shop\/lists\/share\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.LIST_SHARE],
    router: 'pages',
  },
  {
    urlPattern: '/shop/lists/shared/[id]',
    regex: /^\/shop\/lists\/shared\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.LIST_SHARED_DETAIL],
    router: 'pages',
  },
  {
    urlPattern: '/shop/lists/[id]',
    regex: /^\/shop\/lists\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.LIST],
    router: 'pages',
  },
  {
    urlPattern: '/shop/membership-dashboard',
    regex: /^\/shop\/membership\-dashboard(?:\/)?$/,
    routeNames: [RouteName.MEMBERSHIP_DASHBOARD],
    router: 'pages',
  },
  {
    urlPattern: '/shop/membership-dashboard/cancellation',
    regex: /^\/shop\/membership\-dashboard\/cancellation(?:\/)?$/,
    routeNames: [RouteName.CANCELLATION],
    router: 'pages',
  },
  {
    urlPattern: '/shop/need-anything-else',
    regex: /^\/shop\/need\-anything\-else(?:\/)?$/,
    routeNames: [RouteName.NEED_ANYTHING_ELSE],
    router: 'pages',
  },
  {
    urlPattern: '/shop/order-confirmation/[id]',
    regex: /^\/shop\/order\-confirmation\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.ORDER_CONFIRMATION],
    router: 'pages',
  },
  {
    urlPattern: '/shop/products/[id]',
    regex: /^\/shop\/products\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.UNIVERSAL_PRODUCT, RouteName.PRODUCT],
    router: 'pages',
  },
  {
    urlPattern: '/shop/products/[...slug]',
    regex: /^\/shop\/products\/(.+?)(?:\/)?$/,
    routeNames: [RouteName.PRODUCT],
    router: 'pages',
  },
  {
    urlPattern: '/shop/redeem',
    regex: /^\/shop\/redeem(?:\/)?$/,
    routeNames: [RouteName.REDEEM_SIGNUP],
    router: 'pages',
  },
  {
    urlPattern: '/shop/redeem/login',
    regex: /^\/shop\/redeem\/login(?:\/)?$/,
    routeNames: [RouteName.REDEEM_LOGIN],
    router: 'pages',
  },
  {
    urlPattern: '/shop/redeem/payment',
    regex: /^\/shop\/redeem\/payment(?:\/)?$/,
    routeNames: [RouteName.REDEEM_PAYMENT],
    router: 'pages',
  },
  {
    urlPattern: '/shop/search',
    regex: /^\/shop\/search(?:\/)?$/,
    routeNames: [RouteName.SEARCH_REDIRECT],
    router: 'pages',
  },
  {
    urlPattern: '/shop/shoppable-videos',
    regex: /^\/shop\/shoppable\-videos(?:\/)?$/,
    routeNames: [RouteName.SHOPPABLE_VIDEOS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/shoppable-videos/[id]',
    regex: /^\/shop\/shoppable\-videos\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.SHOPPABLE_VIDEO_DETAIL],
    router: 'pages',
  },
  {
    urlPattern: '/shop/special-requests',
    regex: /^\/shop\/special\-requests(?:\/)?$/,
    routeNames: [RouteName.SPECIAL_REQUESTS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/stores/landing-page/[...params]',
    regex: /^\/shop\/stores\/landing\-page\/(.+?)(?:\/)?$/,
    routeNames: [RouteName.GLOBAL_LANDING_PAGE],
    router: 'pages',
  },
  {
    urlPattern: '/shop/stores/search',
    regex: /^\/shop\/stores\/search(?:\/)?$/,
    routeNames: [RouteName.GLOBAL_SEARCH],
    router: 'pages',
  },
  {
    urlPattern: '/shop/substitution-preferences',
    regex: /^\/shop\/substitution\-preferences(?:\/)?$/,
    routeNames: [RouteName.SUBSTITUTION_PREFERENCES],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]',
    regex: /^\/shop\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.RETAILER_HOMEPAGE],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]/coupon/[id]',
    regex: /^\/shop\/([^/]+?)\/coupon\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.RETAILER_COUPON],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]/coupons',
    regex: /^\/shop\/([^/]+?)\/coupons(?:\/)?$/,
    routeNames: [RouteName.RETAILER_COUPONS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]/deals',
    regex: /^\/shop\/([^/]+?)\/deals(?:\/)?$/,
    routeNames: [RouteName.RETAILER_DEALS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]/featured-promotions/[promotion_category_id]',
    regex: /^\/shop\/([^/]+?)\/featured\-promotions\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.RETAILER_FEATURED_PROMOTIONS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]/kits',
    regex: /^\/shop\/([^/]+?)\/kits(?:\/)?$/,
    routeNames: [RouteName.RETAILER_KITS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]/kits/[id]',
    regex: /^\/shop\/([^/]+?)\/kits\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.RETAILER_KIT_DETAIL],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]/landing-page/[...params]',
    regex: /^\/shop\/([^/]+?)\/landing\-page\/(.+?)(?:\/)?$/,
    routeNames: [RouteName.RETAILER_LANDING_PAGE],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]/search',
    regex: /^\/shop\/([^/]+?)\/search(?:\/)?$/,
    routeNames: [RouteName.SEARCH],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]/shoppable-videos',
    regex: /^\/shop\/([^/]+?)\/shoppable\-videos(?:\/)?$/,
    routeNames: [RouteName.RETAILER_SHOPPABLE_VIDEOS],
    router: 'pages',
  },
  {
    urlPattern: '/shop/[store_slug]/shoppable-videos/[id]',
    regex: /^\/shop\/([^/]+?)\/shoppable\-videos\/([^/]+?)(?:\/)?$/,
    routeNames: [RouteName.RETAILER_SHOPPABLE_VIDEO_DETAIL],
    router: 'pages',
  },
  {
    urlPattern: '/shop-next/[store_slug]/deals',
    regex: /^\/shop\-next\/([^/]+?)\/deals(?:\/)?$/,
    routeNames: [RouteName.RETAILER_DEALS],
    router: 'app',
  },
  {
    urlPattern: '/shopper-already-applied',
    regex: /^\/shopper\-already\-applied(?:\/)?$/,
    routeNames: [RouteName.SHOPPER_ALREADY_APPLIED],
    router: 'pages',
  },
  {
    urlPattern: '/signup',
    regex: /^\/signup(?:\/)?$/,
    routeNames: [RouteName.SIGN_UP],
    router: 'pages',
  },
  {
    urlPattern: '/sitemap-index',
    regex: /^\/sitemap\-index(?:\/)?$/,
    routeNames: [RouteName.SITEMAP_INDEX],
    router: 'pages',
  },
  {
    urlPattern: '/sitemap-index/[...slug]',
    regex: /^\/sitemap\-index\/(.+?)(?:\/)?$/,
    routeNames: [RouteName.SITEMAP_INDEX],
    router: 'pages',
  },
  {
    urlPattern: '/target-circle-360',
    regex: /^\/target\-circle\-360(?:\/)?$/,
    routeNames: [RouteName.TARGET_CIRCLE_360],
    router: 'pages',
  },
  {
    urlPattern: '/welcome',
    regex: /^\/welcome(?:\/)?$/,
    routeNames: [RouteName.WELCOME],
    router: 'pages',
  },
  {
    urlPattern: '/[...slug]',
    regex: /^\/(.+?)(?:\/)?$/,
    routeNames: [RouteName.CMS_CATCHALL],
    router: 'pages',
  },
]
